module.exports = __webpack_public_path__ + "img/full4-min.fc3b5e19.png";